import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import "./OptionMenu.scss";

const OptionMenu = ({
  closeOptionMenu,
  openProofModal,
  edit,
  isEditButtonVisible = true
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    const checkElement = (event) => {
      const currentElement = event.target;
      const optionMenu = document.querySelector(".option-menu");

      if (!optionMenu?.contains(currentElement)) {
        closeOptionMenu();
      }
    }

    document.addEventListener('click', (event) => checkElement(event));

    return (
      document.removeEventListener('click', (event) => checkElement(event))
    )
  }, []);

  return (
    <>
      <div className="option-menu">
        {isEditButtonVisible &&
          <div className="option" onClick={edit}>{t('edit')}</div>
        }
        <div className="option_red" onClick={openProofModal}>{t('delete')}</div>
      </div>
    </>
  );
};

export default OptionMenu;